import React from "react";
import { useParams } from "react-router";
import ViewOrderDetails from "./ViewOrderDetails";

function RateContractApprovalsWrapper() {
  let { orderNumber }: any = useParams();
  return (
    <ViewOrderDetails
      orderNumber={orderNumber}
      previousPath="/approvals-rate-contract"
    />
  );
}

export default RateContractApprovalsWrapper;
